import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import { IndividualWithProfessionType } from "../../static/types/commonTypes/individualWithProfessionType"
import individualWithProfessionValidationSchema from "../../utils/validation/individualWithProfessionValidationSchema"
import { civilities } from "../../static/types/commonTypes/individualType"

type IndividualWithPrefessionProps = {
    checked: boolean,
    individual: IndividualWithProfessionType,
    changeIndividual: ( individual: Partial<IndividualWithProfessionType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function IndividualWithProfession ({
    checked,
    individual,
    changeIndividual,
    onValidationChange
}: IndividualWithPrefessionProps ) {

    const { errors, isValid } = useValidation( individual, individualWithProfessionValidationSchema )

    useEffect( () => {
        onValidationChange( isValid )
    }, [ isValid, onValidationChange ])

    return(
        <div className = "mb-3 row">

            
            <div className = "mb-3 row">

                <label htmlFor = "civility" className = "col-sm-3 col-form-label"> Civilité <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-9">

                    <select
                        className = { `form-control ${ ( checked && errors.civility ) ? 'is-invalid' : ''}` }
                        name = "civility"
                        id = "civility"
                        value = { individual.civility }
                        onChange = { event => changeIndividual({ civility: event.target.value as "Monsieur" | "Madame" } )}
                    >
                        {
                            civilities.map( option => 
                                <option key = { option } value = {option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {  ( checked && errors.civility ) && <div className="invalid-feedback"> { errors.civility } </div> }

                </div>

            </div>
            
            <div className = "mb-3 row">
                <label htmlFor = "lastName" className = "col-sm-3 col-form-label"> Nom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-9">

                    <input
                        className = { `form-control ${ ( checked && errors.lastName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "lastName"
                        id = "lastName"
                        value = { individual.lastName }
                        onChange = { event => changeIndividual({ lastName: event.target.value }) }
                    />
                    {  ( checked && errors.lastName ) && <div className="invalid-feedback"> { errors.lastName } </div> }

                </div>
            </div>
            
            <div className = "mb-3 row">
                <label htmlFor = "firstName" className = "col-sm-3 col-form-label"> Prénom <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-9">

                    <input
                        className = { `form-control ${ ( checked && errors.firstName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "firstName"
                        id = "firstName"
                        value = { individual.firstName }
                        onChange = { event => changeIndividual({ firstName: event.target.value }) }
                    />
                    {  ( checked && errors.firstName ) && <div className="invalid-feedback"> { errors.firstName } </div> }

                </div>
            </div>
            
            <div className = "mb-3 row">
                <label htmlFor = "profession" className = "col-sm-3 col-form-label"> Profession <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-9">

                    <input
                        className = { `form-control ${ ( checked && errors.profession ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "profession"
                        id = "profession"
                        value = { individual.profession }
                        onChange = { event => changeIndividual({ profession: event.target.value }) }
                    />
                    {  ( checked && errors.profession ) && <div className="invalid-feedback"> { errors.profession } </div> }

                </div>
            </div>
            
            <div className = "mb-3 row">

                <label htmlFor = "birthName" className = "col-sm-3 col-form-label"> Nom de naissance </label>

                <div className = "col-sm-9">

                    <input
                        className = { `form-control ${ ( checked && errors.birthName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "birthName"
                        id = "birthName"
                        value = { individual.birthName }
                        onChange = { event => changeIndividual({ birthName: event.target.value }) }
                    />
                    {  ( checked && errors.birthName ) && <div className="invalid-feedback"> { errors.birthName } </div> }

                </div>
            </div>
            
            <div className = "mb-3 row">

                <label htmlFor = "nationality" className = "col-sm-3 col-form-label"> Nationalité </label>

                <div className = "col-sm-9">

                    <input
                        className = { `form-control ${ ( checked && errors.nationality ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "nationality"
                        id = "nationality"
                        value = { individual.nationality }
                        onChange = { event => changeIndividual({ nationality: event.target.value }) }
                    />
                    {  ( checked && errors.nationality ) && <div className="invalid-feedback"> { errors.nationality } </div> }

                </div>
            </div>

        </div>
    )
}